export default __webpack_public_path__ + "images/models/5f81b06524d6ec0d5140dc522d6561d5.glb";